"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const Link_1 = __importDefault(require("../../../Link"));
const Text_1 = __importDefault(require("../../../Text"));
const useStyles = core_1.makeStyles((theme) => ({
    step: {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        '&:not(:last-child)': {
            borderBottom: `1px solid ${theme.palette.grey[400]}`,
        },
    },
}));
const StepNavigation = ({ steps, activeStepIndex, maxStepIndex, onStepNavigationClick, getStepNumberLabel, optionalText, disableStepNavigation, }) => {
    const styles = useStyles();
    const renderTitle = react_1.useCallback((step, index) => {
        if (index === activeStepIndex || disableStepNavigation) {
            return (react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Text_1.default, null, index === activeStepIndex ? react_1.default.createElement("b", null, step.title) : step.title)));
        }
        else if (index < activeStepIndex || index <= maxStepIndex) {
            return (react_1.default.createElement(Link_1.default, { href: "#", onClick: () => {
                    onStepNavigationClick === null || onStepNavigationClick === void 0 ? void 0 : onStepNavigationClick({ requestedStepIndex: index });
                } }, step.title));
        }
        return (react_1.default.createElement(Box_1.default, { color: "grey.400" },
            react_1.default.createElement(Text_1.default, null, step.title)));
    }, [activeStepIndex, disableStepNavigation, maxStepIndex, onStepNavigationClick]);
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement(Box_1.default, { maxWidth: "200px" }, steps.map((step, index) => (react_1.default.createElement(Box_1.default, { key: index, "data-testid": "stepNavBox", className: styles.step },
            react_1.default.createElement(Box_1.default, { color: "grey.500" },
                react_1.default.createElement(Text_1.default, { variant: "small" },
                    getStepNumberLabel(index + 1),
                    step.isOptional && react_1.default.createElement("i", null,
                        " - ",
                        optionalText))),
            renderTitle(step, index)))))));
};
exports.default = StepNavigation;
//# sourceMappingURL=index.js.map